import { SET_FILTERS } from '../actions/types';

const initialState = {
	department: 'department',
	state: 'state',
	make: 'make'
};

const setFilters = (state = initialState, action) => {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_FILTERS:
				return {
					...state,
					...action.payload
				};

			// no default
		}
	}

	return state;
};

export default setFilters;
